export default function datetime(val) {
    return val ? val.substring(0, 10) : "";
}